<div class="cookies-box" *ngIf="showPolicyInfo">
    <div class="cookies-container">
        <p class="text">
            {{ 'cookies_policy' | translate }}
        </p>
        <button (click)="onClose()" pButton label="{{'close_btn' | translate}}" class="btn-position ui-button-raised ui-button-success"></button>
    </div>   
</div>